import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * A command sent by the rovo inline input box client to abort the ongoing message
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to abort the ongoing message.
 * Rovo Chat resolves `true` once it has handled the abort. The bridge resolves `undefined` when no
 * receiver handled it.
 */
export const InlineInputBoxAbortMessageCommand: CommandConstructor<
	CommandProperties & { conversationId?: string; isExplicitUserCancellation?: boolean },
	boolean
> = createCommand<
	CommandProperties & { conversationId?: string; isExplicitUserCancellation?: boolean },
	boolean
>('inline-input-box-abort-message-command');
